const mobileMenuBreakpoint = 1200;
const VIEW_ALL_CLASS = 'menu-item--view-all';

const $win = $(window);
const $body = $('body');
const $html = $('html');

const $header = $('header, header.wp-block-template-part, .wp-block-template-part-header');
const $headerNav = $header.find('.wp-classic-menu-block');
const $mobileToggle = $header.find('.mobile-menu-toggle');
const $mobileClose = $header.find('.mobile-close');

function isMobileMenu() {
  return $win.width() <= mobileMenuBreakpoint;
}

function hasNavigableHref(href) {
  return Boolean(href && href !== '#');
}

function getMenuItemLabel($link) {
  return $link.find('.menu-item__label').text().trim() || $link.text().trim();
}

function closeMobileSubmenus() {
  $header.find('.menu-item-has-children.is-submenu-open').removeClass('is-submenu-open');
  $header.find('.menu-item-has-children > a[aria-expanded="true"]').attr('aria-expanded', 'false');
}

function setMobileMenuOpen(isOpen) {
  $headerNav.toggleClass('open', isOpen);
  $html.toggleClass('open', isOpen);
  $mobileToggle.toggleClass('is-active', isOpen).attr('aria-expanded', isOpen ? 'true' : 'false');

  if (!isOpen) {
    closeMobileSubmenus();
  }
}

function toggleMobileSubmenu($item, $link) {
  const isOpen = $item.hasClass('is-submenu-open');

  $item.siblings('.menu-item-has-children.is-submenu-open')
    .removeClass('is-submenu-open')
    .children('a')
    .attr('aria-expanded', 'false');

  $item.toggleClass('is-submenu-open', !isOpen);
  $link.attr('aria-expanded', !isOpen ? 'true' : 'false');
}

function syncMobileViewAllLink($item) {
  const $link = $item.children('a').first();
  const $subMenu = $item.children('.sub-menu');
  const linkHref = $link.attr('href');

  $subMenu.find(`> .${VIEW_ALL_CLASS}`).remove();

  if (!isMobileMenu() || !hasNavigableHref(linkHref)) {
    return;
  }

  const label = getMenuItemLabel($link);
  const $viewAllLink = $('<a></a>')
    .attr('href', linkHref)
    .text('View All');

  if (label) {
    $viewAllLink.attr('aria-label', `View all ${label}`);
  }

  $('<li></li>')
    .addClass(`menu-item ${VIEW_ALL_CLASS}`)
    .append($viewAllLink)
    .appendTo($subMenu);
}

function syncAllMobileViewAllLinks() {
  $header.find('.menu-item-has-children').each(function () {
    syncMobileViewAllLink($(this));
  });
}

function initDesktopMegaMenu($item, $link, $subMenu) {
  let closeTimer;

  function openMegaMenu() {
    clearTimeout(closeTimer);
    $item.addClass('is-mega-open');
  }

  function scheduleCloseMegaMenu() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => $item.removeClass('is-mega-open'), 200);
  }

  $link
    .off('.megaMenu')
    .on('mouseenter.megaMenu', openMegaMenu)
    .on('mouseleave.megaMenu', scheduleCloseMegaMenu);

  $subMenu
    .off('.megaMenu')
    .on('mouseenter.megaMenu', () => clearTimeout(closeTimer))
    .on('mouseleave.megaMenu', scheduleCloseMegaMenu);
}

function initMenuItems() {
  $header.find(`.${VIEW_ALL_CLASS}`).remove();

  $header.find('.menu-item-has-children').each(function () {
    const $item = $(this);
    const $link = $item.children('a').first();
    const $subMenu = $item.children('.sub-menu');

    if ($win.width() > mobileMenuBreakpoint) {
      initDesktopMegaMenu($item, $link, $subMenu);
    } else {
      $link.add($subMenu).off('.megaMenu');
    }

    syncMobileViewAllLink($item);

    $link.off('click.mobileSubmenu').on('click.mobileSubmenu', function (event) {
      if (!isMobileMenu() || !$subMenu.length) {
        return;
      }

      event.preventDefault();
      toggleMobileSubmenu($item, $link);
    });
  });
}

$mobileClose.add($mobileToggle).on('click', () => {
  setMobileMenuOpen(!$headerNav.hasClass('open'));
});

$(document).on('keydown', function (event) {
  if (event.key === 'Escape' && $headerNav.hasClass('open')) {
    setMobileMenuOpen(false);
  }
});

function getHeaderBarHeight() {
  const $bar = $header.children('.wp-block-group').first();

  return ($bar.length ? $bar.outerHeight() : $header.outerHeight()) || 0;
}

function setMenuHeightVar() {
  const height = getHeaderBarHeight();

  if (height > 0) {
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }
}

let resizeTimer;

function handleResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    setMenuHeightVar();
    initMenuItems();
  }, 200);
}

initMenuItems();
setMenuHeightVar();

$win.on('load', setMenuHeightVar);
$win.on('resize', handleResize);

if (typeof ResizeObserver !== 'undefined' && $header.length) {
  const headerBar = $header.children('.wp-block-group').get(0);

  if (headerBar) {
    new ResizeObserver(setMenuHeightVar).observe(headerBar);
  }
}
